import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';
import {TPayoutMerchant, TGroup, TGroupType} from './types';
import {getNiumGroup, TNiumGroupParams} from './nium/mock';
import {getVertoGroup, TVertoGroupParams} from './verto/mock';
import {GROUP_TYPE_NIUM, GROUP_TYPE_VERTO} from './constants';

export const getPayoutMerchantList = (limit: number): TPayoutMerchant[] => {
  return loopMap(limit, getPayoutMerchant) as TPayoutMerchant[];
};

export const getPayoutMerchant = (): TPayoutMerchant => {
  const totalAmount = faker.finance.amount(100, 10000, 2);

  return {
    merchant_id: faker.datatype.uuid(),
    name: faker.name.findName(),
    email: faker.internet.email(),
    currency: faker.finance.currencyCode(),
    total_amount: totalAmount,
    available_amount: faker.finance.amount(100, +totalAmount, 2),
    ...(faker.datatype.boolean() ? {last_withdrawal_date: faker.date.recent().toISOString()} : {}),
    ...(faker.datatype.boolean() ? {next_payout_expected_at: faker.date.recent().toISOString()} : {}),
  } as TPayoutMerchant;
};

export const getGroupList = (groupTypes: TGroupType[], limit: number): TGroup<TGroupType>[] => {
  return loopMap(limit, () => {
    const groupType = (faker.helpers as any).arrayElement(groupTypes);
    return getGroup(groupType);
  }) as TGroup<TGroupType>[];
};

type TGetGroupParams = TNiumGroupParams | TVertoGroupParams;
export const getGroup = (groupType: TGroupType, params: TGetGroupParams = {}): TGroup<TGroupType> => {
  switch (groupType) {
    case GROUP_TYPE_NIUM: return getNiumGroup(params);
    case GROUP_TYPE_VERTO: return getVertoGroup(params);
    default: throw new Error(`Group type with name "${groupType}" is not valid!`);
  }
};
